import { getCompoundsState } from './compounds.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchCompoundsRequest,
} from './compounds.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core'
import { Subscription, Observable } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-compounds',
  templateUrl: './compounds.component.html',
  styleUrls: ['./compounds.component.css'],
})
export class CompoundsComponent extends ListTrait implements OnInit, OnDestroy {
  private state$: Subscription
  private route$: Subscription
  private shouldReload: boolean
  public isLoading: boolean
  public columns: object[] = [
    {
      prop: 'code',
      sortProp: 'code',
      name: 'CODE_COMPOUND',
      sortable: true,
      template: 'code',
    },
    {
      prop: 'name',
      sortProp: 'name',
      name: 'NAME',
      sortable: true,
    },
  ]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getCompoundsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (
          state.get('shouldReload') !== this.shouldReload &&
          state.get('shouldReload')
        ) {
          this.runFilter()
        }
        this.shouldReload = state.get('shouldReload')
      })

    this.route$ = this.route.queryParams.subscribe(this.runFilter.bind(this))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }

  runFilter(queryParams: any = {}) {
    const { page, page_size } = this.state.get('queryParams').toJS()
    const params = { page, page_size, ...queryParams }

    this.store.dispatch<any>(
      new FetchCompoundsRequest({
        filters: {
          ...(params.keyword
            ? {
                or: [{ field: 'code', value: params.keyword }],
              }
            : {}),
        },
        pageSize: parseInt(params.page_size, 10),
        page: parseInt(params.page, 10) - 1,
        sort: {
          order: params.sort?.toUpperCase(),
          prop: params.order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('queryParams', params, 'list'))
  }
}
